import { useMemo } from "react";
import { ReactFlow, ReactFlowProvider, Background, Controls } from "@xyflow/react";
import "@xyflow/react/dist/style.css";
import { nodeTypes } from "../nodes/registry";

/**
 * View-only React Flow render of a template — the real node cards, zoom/pan
 * enabled, nothing editable. Loaded via React.lazy from the template gallery:
 * the registry (and the whole editor node chain behind it) must never be in
 * the list page's synchronous import graph, that's what caused the
 * "reading 'triggerComp'" circular-import crash.
 */
export default function TemplatePreviewFlow({ template, height = 320 }) {
  const nodes = useMemo(
    () => template.nodes.map((n) => ({ ...n, draggable: false, selectable: false, connectable: false })),
    [template]
  );
  // Templates store edges without a type — default bezier keeps the preview
  // free of EdgeV2's interactive affordances.
  const edges = useMemo(
    () => template.edges.map((e) => ({ ...e, type: "default", focusable: false })),
    [template]
  );

  return (
    <div className="template-preview-flow" style={{ height, width: "100%" }}>
      {/* Cards stay fully inert (their inline inputs/buttons included) while
          pan/zoom keeps working on the pane underneath. */}
      <style>{`
        .template-preview-flow .react-flow__node { pointer-events: none !important; }
        .template-preview-flow .react-flow__handle { pointer-events: none !important; }
      `}</style>
      <ReactFlowProvider>
        <ReactFlow
          key={template.id}
          nodes={nodes}
          edges={edges}
          nodeTypes={nodeTypes}
          fitView
          fitViewOptions={{ padding: 0.15 }}
          minZoom={0.1}
          nodesDraggable={false}
          nodesConnectable={false}
          nodesFocusable={false}
          elementsSelectable={false}
          edgesFocusable={false}
          zoomOnScroll
          panOnDrag
          proOptions={{ hideAttribution: true }}
        >
          <Background gap={18} size={1.4} />
          <Controls showInteractive={false} />
        </ReactFlow>
      </ReactFlowProvider>
    </div>
  );
}
